import apiClientService from "./ApiClientService";

const SUBSTITUTIONS_BASE = "/instructor-substitutions";

async function readResponse(res, fallback = null) {
   const text = await res.text().catch(() => "");
   if (!text) return fallback;
   try {
      return JSON.parse(text);
   } catch {
      return text;
   }
}

async function throwApiError(res, fallbackMessage) {
   const payload = await readResponse(res, "");
   const message =
      typeof payload === "string"
         ? payload
         : payload?.message || payload?.error || fallbackMessage;
   throw new Error(message || fallbackMessage);
}

function appendQuery(params = {}) {
   const qs = new URLSearchParams();
   Object.entries(params || {}).forEach(([key, value]) => {
      if (value === null || value === undefined || value === "") return;
      qs.set(key, String(value));
   });
   const query = qs.toString();
   return query ? `?${query}` : "";
}

export async function getInstructorSubstitutions(filters = {}) {
   const res = await apiClientService.get(
      `${SUBSTITUTIONS_BASE}${appendQuery(filters)}`,
   );
   if (!res.ok) {
      await throwApiError(res, "Nu am putut incarca instructorii de schimb.");
   }
   const data = await readResponse(res, []);
   return Array.isArray(data) ? data : [];
}

export async function createInstructorSubstitution(payload) {
   const res = await apiClientService.post(SUBSTITUTIONS_BASE, payload || {});
   if (!res.ok) {
      await throwApiError(res, "Nu am putut crea inlocuirea.");
   }
   return readResponse(res, null);
}

export async function updateInstructorSubstitution(id, payload) {
   const normalizedId = String(id || "").trim();
   if (!normalizedId) throw new Error("ID-ul inlocuirii lipseste.");

   const res = await apiClientService.patch(
      `${SUBSTITUTIONS_BASE}/${encodeURIComponent(normalizedId)}`,
      payload || {},
   );
   if (!res.ok) {
      await throwApiError(res, "Nu am putut actualiza inlocuirea.");
   }
   return readResponse(res, null);
}

export async function deleteInstructorSubstitution(id) {
   const normalizedId = String(id || "").trim();
   if (!normalizedId) throw new Error("ID-ul inlocuirii lipseste.");

   const res = await apiClientService.delete(
      `${SUBSTITUTIONS_BASE}/${encodeURIComponent(normalizedId)}`,
   );
   if (!res.ok && res.status !== 204) {
      await throwApiError(res, "Nu am putut sterge inlocuirea.");
   }
   return true;
}
